import { render } from "./Ma_ProductPriceInsert.vue?vue&type=template&id=0de4365a&scoped=true"
import script from "./Ma_ProductPriceInsert.vue?vue&type=script&lang=js"
export * from "./Ma_ProductPriceInsert.vue?vue&type=script&lang=js"

import "./Ma_ProductPriceInsert.vue?vue&type=style&index=0&id=0de4365a&scoped=true&lang=css"

import exportComponent from "D:\\curProject\\newTrip\\client\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0de4365a"]])

export default __exports__